import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ReceivingPlan } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormInput, FormItems } from './component/form';

const initialState = {
  data: null,
  form: null,
  items: [],
};

const UpdateScreen = ({match}) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ form, items, data }, setState] =
    React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(ReceivingPlan.$show(id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  const $handleSubmit = async () => {
    const payload = {
      schedule_at: form?.schedule_at?.formatted,
      ref_code: form?.ref_code,
      sender: form?.sender,
      note: form?.note,
      ...items,
    };

    const req = await Dispatch(ReceivingPlan.$update(data?.id, payload));

    if (req?.message === 'success') {
      History?.push(`/receiving/plan/${req?.data?.id}`);
    }
  };

  const $handleItemsChange = async (e) => {
    setState((prevState) => ({ ...prevState, items: e }));
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className="col-md-6 bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Rencana Penerimaan" />
      <Page.Body className="d-block px-3 py-3">
        <div className="row">
          <FormInput isLoading={StateForm?.is_loading} data={data} onInputChange={(e) => setState((prevState) => ({ ...prevState, form: e }))} />
          <FormItems isLoading={StateForm?.is_loading} data={data} onItemChange={$handleItemsChange} />
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/receiving/plan`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
